<template>
  <div>
    <div class="md-layout">
      <div class="md-layout-item md-size-100">
        <h5 class="info-text">¿Qué tipo de problema has tenido?</h5>
      </div>
      <div class="md-layout-item md-layout md-size-100 md-alignment-center-space-around">
        <div class="md-layout-item md-size-66 md-medium-size-100 md-small-size-100">
          <md-field>
            <label for="movie">Incidencia</label>
            <md-select v-model="product.problemType" name="incidencia" id="incidencia">
              <md-option value="Calidad">Hay algún problema relacionado con la calidad del producto</md-option>
              <md-option value="Cantidad">Falta algún ingrediente o hay poca cantidad de producto</md-option>
              <md-option value="Envoltorio">El envase está dañado, abierto o mal impreso</md-option>
            </md-select>
          </md-field>
        </div>
      </div>
      <div class="md-layout-item md-size-100">
        <md-field>
          <label>Describa con detalle la incidencia encontrada</label>
          <md-textarea v-model="product.problemDesc"></md-textarea>
        </md-field>
      </div>
    </div>

    <div class="md-layout-item md-size-100">
      <h5 class="info-text">
        <md-checkbox v-model="sendPhoto">Quieres mandarnos una foto o una instantánea.</md-checkbox>
      </h5>
    </div>
    <div class="md-layout-item md-size-100 md-alignment-center-space-around" v-if="sendPhoto">
      <div class="type-selector" v-if="product.images.length<3">
        <md-button class="md-primary md-fileinput btn-selector">
          <template>Subir Foto</template>
          <input type="file" @change="onFileChange" />
        </md-button>
        <md-button
          class="md-primary btn-selector"
          :class="getPhotoButtonClass()"
          @click="checkPhoto()"
        >Hacer Foto</md-button>
      </div>
      <div
        class="md-layout-item md-size-100 md-alignment-center-center camara-wrapper"
        v-if="product.images.length<3 && makePhoto"
      >
        <div class="camara-container">
          <video ref="video" class="camera-stream" autoplay muted playsinline />
        </div>
        <div class="btn-camera-container">
          <md-button class="md-icon-button md-primary md-round btn-camara" @click="capture()">
            <md-icon class="md-size-3x">camera</md-icon>
          </md-button>
        </div>
      </div>
      <div class="md-layout-item md-layout md-size-100 container-selected-images">
        <div
          v-for="(imgCapture, index) in product.images"
          :key="imgCapture"
          class="md-layout-item md-size-33"
        >
          <div class="image-container">
            <img :src="imgCapture" />
          </div>
          <div class="button-container">
            <md-button class="md-danger md-round" @click="removeImage(index)">
              <i class="fa fa-times"></i>Eliminar
            </md-button>
          </div>
        </div>
        <div style="display:none">
          <canvas ref="snapshot" width="1024" height="768" style="visibility:hidden"></canvas>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import { SlideYDownTransition } from "vue2-transitions";
import { apiServer, staticServer } from "@/globalVars.js";

export default {
  name: "StepProduct",
  components: { SlideYDownTransition },
  props: {
    product: {
      type: Object,
      required: false,
      default: () => {
        null;
      }
    }
  },
  data() {
    return {
      robot: false,
      problemType: 0,
      mediaStream: null,
      regularImg: "./img/image_placeholder.jpg",
      sendPhoto: false,
      makePhoto: false
    };
  },
  model: {
    event: "next"
  },
  methods: {
    setType(type) {
      this.product.problemType = type;
      switch (type) {
        case 1:
          this.product.problemDesc = "Ingredientes";
          break;

        case 2:
          this.product.problemDesc = "Mal Estado";
          break;
        case 3:
          this.product.problemDesc = "Cuerpos Extraños";
          break;
        case 4:
          this.product.problemDesc = "Envoltorio";
          break;

        default:
          this.product.problemDesc = "Ingredientes";
          break;
      }
    },
    getButtonClass(type) {
      if (this.product.problemType == type) {
        return "button-selected";
      }
      return "";
    },
    getPhotoButtonClass() {
      if (this.makePhoto) {
        return "button-selected";
      }
      return "";
    },
    checkPhoto() {
      this.makePhoto = !this.makePhoto;
      if (this.makePhoto) {
        this.reloadCamera();
      } else {
        destroyCamera();
      }
    },
    capture() {
      var context = this.$refs.snapshot.getContext("2d");
      context.drawImage(
        this.$refs.video,
        0,
        0,
        this.$refs.snapshot.width,
        this.$refs.snapshot.height
      );
      let self = this;
      this.$refs.snapshot.toBlob(function(blob) {
        self.product.images.push(URL.createObjectURL(blob));
        let blob_file = new File([blob], "capture_image", {
          type: "image/jpeg",
          lastModified: Date.now()
        });
        self.product.files.push(blob_file);
      });

      // const mediaStreamTrack = this.mediaStream.getVideoTracks()[0];
      // const imageCapture = new window.ImageCapture(mediaStreamTrack);
      // return imageCapture.takePhoto().then(blob => {
      //   this.product.images.push(URL.createObjectURL(blob));
      //   let blob_file = new File([blob], "capture_image", {
      //     type: "image/jpeg",
      //     lastModified: Date.now()
      //   });
      //   this.product.files.push(blob_file);
      // });
    },
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate() {
      // return this.$validator.validateAll().then(res => {
      //   this.$emit("on-validated", res);
      //   return res;
      // });

      return true;
    },
    onFileChange(e) {
      let files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.createImage(files[0]);
    },
    createImage(file) {
      let reader = new FileReader();
      let vm = this;
      reader.onload = e => {
        this.product.images.push(e.target.result);
      };
      this.product.files.push(file);
      reader.readAsDataURL(file);
    },
    removeImage: function(index) {
      this.product.images.splice(index, 1);
      this.reloadCamera();
    },
    reloadCamera() {
      navigator.mediaDevices
        .getUserMedia({ video: { facingMode: "environment" } })
        .then(mediaStream => {
          this.mediaStream = mediaStream;
          this.$refs.video.srcObject = mediaStream;
          this.$refs.video.play();
        })
        .catch(error => console.error("getUserMedia() error:", error));
    },
    destroyCamera() {
      if (this.mediaStream != null) {
        const tracks = this.mediaStream.getTracks();
        tracks.map(track => track.stop());
        //this.mediaStream.close();
      }
    }
  },
  watch: {},
  mounted() {},
  destroyed() {
    this.destroyCamera();
  }
};
</script>


<style scoped>
.md-menu-content {
  max-width: 400px;
  width: 400px;
}
.container-selected-images {
  margin-top: 30px;
}
.widthSet {
  max-width: 200px;
}
.button-selected {
  background-color: #004d40 !important;
}
.button-selected:hover {
  background-color: #004d40 !important;
}
.button-selected:active {
  background-color: #004d40 !important;
}
.button-selected:focus {
  background-color: #004d40 !important;
}
.img-tipo {
  width: 300px;
  height: 186px;
}
.md-tooltip {
  max-width: 500px !important;
}
.camara-container {
  display: inline;
}
.btn-camara {
  width: 100px;
  height: 50px;
}
.btn-camera-container {
  position: relative;
  top: -100px;
}
.camara-wrapper {
  padding: 0;
}
.image-wrapper {
  margin: 10px;
}
.type-selector {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  width: 100%;
}

@media (max-width: 992px) {
  .type-selector {
    padding-top: 20px;
    padding-bottom: 20px;
  }
  .btn-selector {
    width: 100%;
  }
}
</style>
